import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import { store } from './services/store'
import vueCustomElement from 'vue-custom-element'
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
import Vuelidate from 'vuelidate'
import VueNumeric from 'vue-numeric'
import VueGtag from "vue-gtag";
import 'document-register-element/build/document-register-element';
import '@babel/polyfill/dist/polyfill.min'

Vue.filter('numFormat', numFormat(numeral));
Vue.use(Vuelidate);
Vue.use(vueCustomElement);
Vue.use(VueNumeric)
Vue.use(VueGtag, {
    config: {
        id: "UA-31918228-4",
        bootstrap: false
    }
});

Vue.config.productionTip = false

App.store = store;
App.router = router;

Vue.customElement('ir35-calculator', App)
